import http from './http.service';

export class ContactUsService {

    sendMail(contactInfo) {
        return http.post('/contactus', contactInfo).then(x => x.data);
    }

    sendVendorSignupMail(contactInfo) {
        return http.post('/contactvendorsignup', contactInfo).then(x => x.data);
    }

    signupWithFormex(signupData) {
        return http.post('/formexsignup', signupData).then(x => x.data);
    }
}